import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { getKey } from "../helpers/sessionKey";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import DailyNote from "../pages/DailyNote/DailyNote";
import CreateDailyNote from "../pages/DailyNote/CreateDailyNote";
import EditDailyNote from "../pages/DailyNote/EditDailyNote";

export const queryClient = new QueryClient();
const DailyNoteRouter = () => {

  return(
     <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <Routes>
            <Route
            path={"/daily-notes"}
            element={<DailyNote />}
          />
          <Route
            path={"daily-notes/create"}
            element={<CreateDailyNote />}
          />
          <Route
            path={"/daily-notes/edit/:id"}
            element={<EditDailyNote />}
          />
        </Routes>
        </BrowserRouter>
    </QueryClientProvider>
  )
}
export default DailyNoteRouter;